// extracted by mini-css-extract-plugin
module.exports = {"comp":"PartnerForm_comp__jFmgG"};